import * as React from 'react';
import DatePicker from 'react-datepicker';
import { getIconName, iconName } from '../icons/Icons';
import { DateInputGlobalStyle, DateTimeIconContainer, DateTimeWrapper, MasterWrapper } from './DateInput';
import { textInputPadding } from './TextInput';

export type TimeInputProps = {
    id?: string,
    value: Date | null,
    onValueChange: (value: Date | null) => void,
    timeIntervals?: number,
    disabled?: boolean,
    inErrorState?:boolean,
    width?:string
    noBorder?: boolean,
    fontSize?: 14 | 16,
    icon?: iconName
}
export function TimeInput(props: TimeInputProps) {

    const handleChange = (date: Date | undefined) => {
        const valueDate = date || null;
        props.onValueChange(valueDate);
    }

    const disabled = props.disabled === undefined ? false : props.disabled;
    const inErrorState = props.inErrorState === undefined ? false : props.inErrorState;
    const { paddingVertical, paddingHorizontal } = textInputPadding(props.fontSize);

    return (
        <MasterWrapper wrapperWidth={props.width || '150px'}>
            <DateTimeWrapper disabled={disabled} inErrorState={inErrorState} noBorder={props.noBorder===true} fontSize={props.fontSize || 16} paddingVertical={paddingVertical} paddingHorizontal={paddingHorizontal}>
                <DatePicker
                    wrapperClassName='amorg_date_picker_wrapper'
                    className='amorg_time_picker_input'
                    selected={props.value}
                    onChange={handleChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={props.timeIntervals || 5}
                    dateFormat="HH:mm" // input
                    timeFormat="HH:mm" // dropdown 
                    disabled={props.disabled}
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }} />
                <DateTimeIconContainer disabled={disabled} inErrorState={inErrorState} noBorder={props.noBorder===true}>
                    {getIconName(props.icon || "clock")}
                </DateTimeIconContainer>
            </DateTimeWrapper>
            <DateInputGlobalStyle />
        </MasterWrapper>
    );
}